import { render, staticRenderFns } from "./LoginModalComponent.vue?vue&type=template&id=15259b8c"
import script from "./LoginModalComponent.vue?vue&type=script&lang=js"
export * from "./LoginModalComponent.vue?vue&type=script&lang=js"
import style0 from "./LoginModalComponent.vue?vue&type=style&index=0&id=15259b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports